import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
axios.defaults.baseURL = window.location.hostname == "localhost" ? "http://192.168.1.80/api/api/" :   "https://okul-backend.orkestrasefi.com/api/"
axios.defaults.base =  window.location.hostname == "localhost" ? "http://192.168.1.80/api/" : "https://okul-backend.orkestrasefi.com/"
console.log(window.location.hostname == "localhost")
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);